// Minimal money formatter compatible with Shopify's money_format placeholders.
// Used by cart.js, product.js, and inline section JS.
(function () {
  window.Shopify = window.Shopify || {};
  if (window.Shopify.formatMoney) return;

  var PLACEHOLDERS = {
    amount: /\{\{\s*amount\s*\}\}/g,
    amount_no_decimals: /\{\{\s*amount_no_decimals\s*\}\}/g,
    amount_with_comma_separator: /\{\{\s*amount_with_comma_separator\s*\}\}/g,
    amount_no_decimals_with_comma_separator: /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
    amount_with_space_separator: /\{\{\s*amount_with_space_separator\s*\}\}/g,
    amount_no_decimals_with_space_separator: /\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g,
    amount_with_apostrophe_separator: /\{\{\s*amount_with_apostrophe_separator\s*\}\}/g
  };

  window.Shopify.formatMoney = function (cents, format) {
    var fmt = format || window.Shopify.moneyFormat || '${{amount}}';
    var value = (typeof cents === 'string'
      ? parseFloat(cents.replace(/[^0-9.-]/g, ''))
      : Number(cents)) / 100;
    if (isNaN(value)) value = 0;
    // Match live Hydrogen <Money> ("₹240.00") regardless of the store's money_format (see snippets/money.liquid).
    var cur = window.Shopify.currency && window.Shopify.currency.active;
    if (!format && cur === 'INR' && typeof Intl !== 'undefined') {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'INR' }).format(value);
    }

    function thousands(n, separator) {
      var parts = n.toString().split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + separator);
      return parts.join('.');
    }

    var fixed = value.toFixed(2);
    var amountComma = thousands(fixed, ',');
    var amountNoDecComma = thousands(Math.floor(value), ',');
    var amountDot = thousands(fixed.replace('.', ','), '.');
    var amountNoDecDot = thousands(Math.floor(value), '.');
    var amountSpace = thousands(fixed, ' ');
    var amountNoDecSpace = thousands(Math.floor(value), ' ');
    var amountApos = thousands(fixed, "'");

    return fmt
      .replace(PLACEHOLDERS.amount, amountComma)
      .replace(PLACEHOLDERS.amount_no_decimals, amountNoDecComma)
      .replace(PLACEHOLDERS.amount_with_comma_separator, amountDot)
      .replace(PLACEHOLDERS.amount_no_decimals_with_comma_separator, amountNoDecDot)
      .replace(PLACEHOLDERS.amount_with_space_separator, amountSpace)
      .replace(PLACEHOLDERS.amount_no_decimals_with_space_separator, amountNoDecSpace)
      .replace(PLACEHOLDERS.amount_with_apostrophe_separator, amountApos);
  };
})();
